/**
 * Directive: notice
 */
angular.module('acme.common.directive.notice', [])
.directive('notice', [ '$log','$timeout', function($log, $timeout) {

    return {
      restrict: 'A',
      replace: false,
      templateUrl: 'common/directives/notice/notice.tpl.html',
      scope: {
        errors: '=',
        type: '@',
        duration: '='
      },

      link: function($scope, $element, $attrs) {
        // Modified after controller runs
        $scope.$watch('errors', function (value) {
          $scope.notice.errors = value;
          
          if ($scope.duration) {
            startTimer();
          }
        });
        
        function startTimer() {
          var seconds = $scope.duration * 1000;
          $timeout(function () {
            $scope.notice.errors = [];
          }, seconds);
        }
        
      },

      controller: ['$scope', '$log', function($scope) {

        $scope.notice = {
          errors: [],
          type: $scope.type || 'danger'
        };

      }]

    };

}]);